import * as React from 'react';
import {Box, Button, Card, CardContent, CardHeader, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, OutlinedInput, Switch, TextField,} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import UserContext from '../../../../Contexts/UserContext/UserContext';
import {useSessionContext} from 'supertokens-auth-react/recipe/session';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import APIWrapperContext from '../../../../services/APIWrapperContext';
import {UserService} from '../../../../services/openapi';
import ServiceWorkerUI from "../../../ServiceWorkerUI";
import packageJson from '../../../../../package.json';
import {useEffect} from "react";

export default function UserOptions() {
    const [secondary, setSecondary] = React.useState(false);
    let theme = useTheme();
    const {user_roll, email, additionalUserdata} = React.useContext(UserContext);
    const sessionContext = useSessionContext();
    const [isEditingEmail, setIsEditingEmail] = React.useState(false);

    const [values, setValues] = React.useState({
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
        email: email,

        showOldPassword: false,
        showNewPassword1: false,
        showNewPassword2: false,
    });

    const handleChangeText =
        (prop: string) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setValues({...values, [prop]: event.target.value});
        };

    const handleClickShowPasswordOld = () => {
        setValues({
            ...values,
            showOldPassword: !values.showOldPassword,
        });
    };
    const handleClickShowPasswordNew1 = () => {
        setValues({
            ...values,
            showNewPassword1: !values.showNewPassword1,
        });
    };
    const handleClickShowPasswordNew2 = () => {
        setValues({
            ...values,
            showNewPassword2: !values.showNewPassword2,
        });
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
    };

    const {call_backend_api} = React.useContext(APIWrapperContext);

    const handleClick_Change_PW = () => {
        if (values.newPassword1 === values.newPassword2) {
            call_backend_api(
                UserService.changeUsersPasswordUserMeChangePwPost(values.oldPassword, values.newPassword1),
                undefined,
                undefined,
                undefined,
                true,
                'Passwort erfolgreich geändert!',
                'Fehler: Passwort konnte nicht geändert werden!'
            );
        }
    };
    const handleClick_Change_Email = () => {
        if (values.email && values.email !== '') {
            call_backend_api(
                UserService.changeUsersEmailUserMeChangeEmailPost(values.email),
                undefined,
                undefined,
                undefined,
                true,
                'E-mail erfolgreich geändert!',
                'Fehler: E-Mail konnte nicht geändert werden!'
            );
            setIsEditingEmail(false);
        }
    };

    const [emailNotifications, setEmailNotifications] = React.useState(additionalUserdata?.email_notifications === 'true');

    useEffect(() => {
        setEmailNotifications(additionalUserdata?.email_notifications === 'true');
    }, [additionalUserdata]);

    const changeAdditionalUserData = (email_notification: boolean) => {
        const userId = (sessionContext as any).userId;
        if (!userId) {
            console.error('User ID is not available');
            return;
        }
        call_backend_api(
            UserService.addAdditionalUserDataUserAddAdditionalUserDataPost(
                userId,
                'email_notifications',
                email_notification.toString()
            ),
            undefined,
            undefined,
            undefined,
            true,
            'E-Mail-Benachrichtigungen erfolgreich aktualisiert!',
            'Fehler: E-Mail-Benachrichtigungen konnten nicht aktualisiert werden!'
        );
    };

    const handleEmailNotificationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.checked;
        setEmailNotifications(newValue);
        changeAdditionalUserData(newValue);
    };

    const customTitle = (
        <Box sx={{textAlign: 'left'}}>
            <Typography
                variant='h4'
                sx={{
                    fontWeight: 'bold',
                }}>
                Mein Account
            </Typography>
        </Box>
    );

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                width: '100%',
                maxWidth: 'lg',
                ml: 'auto',
                mr: 'auto',
                mb: 3,
            }}>
            {/* Personal Data & Email Management Card */}
            <Card sx={{p: {xs: 1, sm: 2, md: 3}}}>
                <CardHeader title={customTitle}/>
                <CardContent>

                    <Box>
                        <Typography variant='body2' color='text.secondary' sx={{mb: 1}}>
                            E-Mail-Adresse:
                        </Typography>

                        {!isEditingEmail ? (
                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                <Typography variant='body1' sx={{fontWeight: 'medium'}}>
                                    {String(email)}
                                </Typography>
                                <IconButton
                                    size='small'
                                    onClick={() => setIsEditingEmail(true)}
                                    sx={{
                                        color: 'primary.main',
                                        '&:hover': {backgroundColor: 'rgba(25, 118, 210, 0.08)'},
                                    }}>
                                    <EditIcon fontSize='small'/>
                                </IconButton>
                            </Box>
                        ) : (
                            <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, maxWidth: '500px'}}>
                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                    <TextField
                                        fullWidth
                                        required
                                        id='outlined-required'
                                        label='Neue E-Mail-Adresse'
                                        defaultValue=''
                                        value={values.email}
                                        onChange={handleChangeText('email')}
                                        size='small'
                                    />
                                    <IconButton
                                        size='small'
                                        onClick={() => setIsEditingEmail(false)}
                                        sx={{
                                            color: 'text.secondary',
                                            '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.04)'},
                                        }}>
                                        <CloseIcon fontSize='small'/>
                                    </IconButton>
                                </Box>
                                <Box sx={{display: 'flex', gap: 1}}>
                                    <Button variant='contained' onClick={handleClick_Change_Email} size='medium'>
                                        E-Mail ändern
                                    </Button>
                                    <Button variant='outlined' onClick={() => setIsEditingEmail(false)} size='medium'>
                                        Abbrechen
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </CardContent>
            </Card>

            {/* Change Password Card */}
            <Card sx={{p: {xs: 1, sm: 2, md: 3}}}>
                <CardHeader title='Passwort ändern'/>
                <CardContent>
                    <Typography sx={{mb: 3}}>Ändern Sie Ihr Passwort hier ab:</Typography>
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, maxWidth: '400px'}}>
                        <FormControl variant='outlined'>
                            <InputLabel htmlFor='outlined-adornment-password' required>
                                Altes Passwort
                            </InputLabel>
                            <OutlinedInput
                                id='outlined-adornment-password'
                                type={values.showOldPassword ? 'text' : 'password'}
                                value={values.oldPassword}
                                onChange={handleChangeText('oldPassword')}
                                endAdornment={
                                    <InputAdornment position='end'>
                                        <IconButton
                                            aria-label='toggle password visibility'
                                            onClick={handleClickShowPasswordOld}
                                            onMouseDown={handleMouseDownPassword}
                                            edge='end'>
                                            {values.showOldPassword ? <VisibilityOff/> : <Visibility/>}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label='Altes Passwort'
                            />
                        </FormControl>
                        <FormControl variant='outlined'>
                            <InputLabel htmlFor='outlined-adornment-password-new1' required>
                                Neues Passwort
                            </InputLabel>
                            <OutlinedInput
                                id='outlined-adornment-password-new1'
                                type={values.showNewPassword1 ? 'text' : 'password'}
                                value={values.newPassword1}
                                onChange={handleChangeText('newPassword1')}
                                endAdornment={
                                    <InputAdornment position='end'>
                                        <IconButton
                                            aria-label='toggle password visibility'
                                            onClick={handleClickShowPasswordNew1}
                                            onMouseDown={handleMouseDownPassword}
                                            edge='end'>
                                            {values.showNewPassword1 ? <VisibilityOff/> : <Visibility/>}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label='Neues Passwort'
                            />
                        </FormControl>
                        <FormControl variant='outlined'>
                            <InputLabel htmlFor='outlined-adornment-password-new2' required>
                                Neues Passwort wiederholen
                            </InputLabel>
                            <OutlinedInput
                                id='outlined-adornment-password-new2'
                                type={values.showNewPassword2 ? 'text' : 'password'}
                                value={values.newPassword2}
                                onChange={handleChangeText('newPassword2')}
                                endAdornment={
                                    <InputAdornment position='end'>
                                        <IconButton
                                            aria-label='toggle password visibility'
                                            onClick={handleClickShowPasswordNew2}
                                            onMouseDown={handleMouseDownPassword}
                                            edge='end'>
                                            {values.showNewPassword2 ? <VisibilityOff/> : <Visibility/>}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label='Neues Passwort wiederholen'
                            />
                        </FormControl>
                        <Button
                            variant='contained'
                            onClick={handleClick_Change_PW}
                            sx={{alignSelf: 'flex-start'}}>
                            Passwort ändern
                        </Button>
                    </Box>
                </CardContent>
            </Card>

            {/* Email Notifications Card */}
            <Card sx={{p: {xs: 1, sm: 2, md: 3}}}>
                <CardHeader title='E-Mail-Benachrichtigungen'/>
                <CardContent>
                    <Typography sx={{mb: 2}}>
                        Verwalten Sie Ihre E-Mail-Benachrichtigungseinstellungen:
                    </Typography>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={emailNotifications}
                                onChange={handleEmailNotificationChange}
                                color='primary'
                            />
                        }
                        label='E-Mail-Benachrichtigungen aktivieren'
                    />
                </CardContent>
            </Card>
            {user_roll && (user_roll.includes('Administrator') || user_roll.includes('Aufgaben Mitarbeiter') || user_roll.includes('Zeiterfassung Mitarbeiter') || user_roll.includes('Admin Aufgaben')) && (
                <Card sx={{p: {xs: 1, sm: 2, md: 3}}}>
                    <CardHeader title='Benachrichtigungen'/>
                    <CardContent>
                        <Typography sx={{mb: 2}}>
                            Push Benachrichtigungen aktivieren:
                        </Typography>
                        <ServiceWorkerUI/>
                    </CardContent>
                </Card>
            )}

            {/* Version Display */}
            <Box sx={{
                textAlign: 'center',
                mt: 2,
                mb: 1
            }}>
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.disabled',
                        fontSize: '12px !important',
                        opacity: 0.6
                    }}
                >
                    Version {packageJson.version}
                </Typography>
            </Box>
        </Box>
    );
}
